import store from 'store';
import { PATIENT_API_BASE_URL, SCREENING_ENDPOINT_SUFFIX } from '../config/api-endpoints'
import { LOCAL_STORAGE_AUTH_KEY } from '../config/constants';
import AuthService from '../services/AuthService'
import AuthGuestLoggedin from '../services/AuthGuestLoggedinService';

// eslint-disable-next-line import/prefer-default-export
export const postScreeningAPICall = async (data) => {
  let guid = store.get(LOCAL_STORAGE_AUTH_KEY.GUEST_ID);
  const authCheck = new AuthGuestLoggedin()
  if (authCheck.loggedIn()) {
    const auth = new AuthService();
    const profile = auth.getUserProfile();
    guid = profile.guid;
  }

  try {
    const config = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }
    const endpointToHit = PATIENT_API_BASE_URL + guid + SCREENING_ENDPOINT_SUFFIX
    const response = await window.fetch(endpointToHit, config)
    const responseOk = await response.status === 200
    const responseJSON = await response.json()
    return { responseOk, responseJSON }

  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('ERROR: ', e)
    return e
  }
}

